import { useWeb3React } from "@web3-react/core";
import { useEffect, useState } from "react";
import { RibbonV2ThetaVaultFactory } from "../codegen/RibbonV2ThetaVaultFactory";
import { isSolanaVault, VaultAddressMap, } from "../constants/constants";
import { useWeb3Context } from "./web3Context";
export var getV2VaultContract = function (library, vaultOption, useSigner) {
    if (useSigner === void 0) { useSigner = true; }
    if (!VaultAddressMap[vaultOption].v2) {
        return null;
    }
    var provider = useSigner ? library.getSigner() : library;
    switch (vaultOption) {
        // case "rstETH-THETA":
        //   return RibbonV2stETHThetaVaultFactory.connect(
        //     VaultAddressMap[vaultOption].v2!,
        //     provider
        //   );
        default:
            return RibbonV2ThetaVaultFactory.connect(VaultAddressMap[vaultOption].v2, provider);
    }
};
var useV2VaultContract = function (vaultOption) {
    var _a = useWeb3React(), active = _a.active, library = _a.library;
    var provider = useWeb3Context().provider;
    var _b = useState(null), vault = _b[0], setVault = _b[1];
    useEffect(function () {
        if (isSolanaVault(vaultOption))
            return;
        var vault = getV2VaultContract(library || provider, vaultOption, active);
        setVault(vault);
    }, [active, library, provider, vaultOption]);
    return vault;
};
export default useV2VaultContract;
//# sourceMappingURL=useV2VaultContract.js.map